





























import Vue from "vue";
import ScrollReveal from "scrollreveal";
import HeaderImg from "@/components/shared/header-img/HeaderImg.vue";
import JobOpenings from "@/components/careers-view/job-openings/JobOpenings.vue";
import { scrollConfig } from "@/resources/animations/configs.ts";
import { getJobOpenings } from "@/resources/content/jobOpenings.ts";

export default Vue.extend({
  name: "Careers",
  components: {
    HeaderImg,
    JobOpenings
  },
  data() {
    return {
      careersHeaderImg: {
        path: "careers",
        image: "",
        imageAlt: "careers top img"
      },
      jobsList: getJobOpenings()
    };
  },
  created() {
    this.careersHeaderContent();
  },
  mounted() {
    window.scrollTo(0, 0);
    this.setRevealAnimation();

    window.addEventListener("resize", () => this.careersHeaderContent());
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => this.careersHeaderContent());
  },
  methods: {
    setRevealAnimation() {
      ScrollReveal().reveal(`.jobList`, scrollConfig);
    },
    careersHeaderContent() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const desktopViewport = width > 599;
      this.careersHeaderImg = {
        ...this.careersHeaderImg,
        image: desktopViewport
          ? "desktop_careers_top_img.jpg"
          : "mobile_careers_top_img.jpg"
      };
    }
  }
});
